$('body,html').animate({ scrollTop: 0 }, 0);

// 新規登録画面に生年月日を追加
$(function() {
  $('.customer.register').each(function(){
    // 現在の年月日を取得
    var time = new Date();
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();

    // 選択された年月日を取得
    var selected_year = document.getElementById("year").value;
    var selected_month = document.getElementById("month").value;

    // 年(初期): 1920〜現在の年 の値を設定
    for (var i = year; i >= 1920 ; i--) {
      $('#year').append('<option value="' + i + '年">' + i + '</option>');
    }

    // 月(初期): 1~12 の値を設定
    for (var j = 1; j <= 12; j++) {
      $('#month').append('<option value="' + j + '月">' + j + '</option>');
    }

    // 日(初期): 1~31 の値を設定
    for (var k = 1; k <= 31; k++) {
      $('#date').append('<option value="' + k + '日">' + k + '</option>');
    }

    // 月(変更)：選択された年に合わせて、適した月の値を選択肢にセットする
    $('#year').change(function() {
      selected_year = $('#year').val().replace(/年/g, '');

      // 現在の年が選択された場合、月の選択肢は 1~現在の月 に設定
      // それ以外の場合、1~12 に設定
      var last_month = 12;
      if (selected_year == year) {
        last_month = month;
      }
      $('#month').children('option').remove();
      $('#month').append('<option value="誕生月：なし"></option>');
      for (var n = 1; n <= last_month; n++) {
        $('#month').append('<option value="' + n + '月">' + n + '</option>');
      }
    });

    // 日(変更)：選択された年・月に合わせて、適した日の値を選択肢にセットする
    $('#year,#month').change(function() {
      selected_year = $('#year').val().replace(/年/g, '');;
      selected_month = $('#month').val().replace(/月/g, '');;

      // 現在の年・月が選択された場合、日の選択肢は 1~現在の日付 に設定
      // それ以外の場合、各月ごとの最終日を判定し、1~最終日 に設定
      if (selected_year == year && selected_month == month ) {
        var last_date = date;
      }else{
        // 2月：日の選択肢は1~28日に設定
        // ※ ただし、閏年の場合は29日に設定
        if (selected_month == 2) {
          if((Math.floor(selected_year%4 == 0)) && (Math.floor(selected_year%100 != 0)) || (Math.floor(selected_year%400 == 0))){
            last_date = 29;
          }else{
            last_date = 28;
          }

        // 4, 6, 9, 11月：日の選択肢は1~30日に設定
        }else if(selected_month == 4 || selected_month == 6 || selected_month == 9 || selected_month == 11 ){
          last_date = 30;

        // 1, 3, 5, 7, 8, 10, 12月：日の選択肢は1~31日に設定
        }else{
          last_date = 31;
        }
      }

      $('#date').children('option').remove();
      $('#date').append('<option value="誕生日：なし"></option>');
      for (var m = 1; m <= last_date; m++) {
        $('#date').append('<option value="' + m + '日">' + m + '</option>');
      }
    });
  });
});

// TOP FV
$(function () {
  $('.p-top__fv__btnbox').delay(0).queue(function () {
    $(this).addClass('js-fadein');
  });
  
  // 音声ON/OFF
  var video = $("video").get(0);
  $(".js-mute-on").on("click",function(){
    video.muted = true;
    $(".js-mute-on").hide();
    $(".js-mute-off").show();
  });
  $(".js-mute-off").on("click",function(){
    video.muted = false;
    $(".js-mute-off").hide();
    $(".js-mute-on").show();
  });
});

//ハンバーガーメニュー
$(function() {
  var state = false;
  var scrollpos;
  $(document).on("click", ".c-header__navToggle", function() {
    $(".c-header__navToggle").toggleClass("js-active");
    $(".c-header__globalmenu").toggleClass("js-active");
    $(".c-header__logo").toggleClass("js-smalled");
    if(state == false) {
      scrollpos = $(window).scrollTop();
      $("body").addClass("js-fixed").css({'top': -scrollpos});
      $(".c-header").addClass("fixed");
      state = true;
    } else {
      $("body").removeClass("js-fixed");
      $(".c-header").removeClass("fixed");
      $(window).scrollTop(scrollpos, scrollpos);
      state = false;
    }
  });

  $(".c-header__globalmenu__listitem__link").on("click", function() {
    $(".c-header__navToggle").click();
  });
});

//ヘッダー検索開閉
$(function() {
  if (window.innerWidth > 768) {
    $(document).on("click", ".c-header__search__toggle", function() {
      $(".c-header__search__input").toggleClass("js-active");
      $(".c-header__searchbox").toggleClass("js-active");
    });
  }
});

//ヘッダー上にスクロールした時に表示
$(function(){
  var pos = 0;
  var header = $('.c-header');
  // var h = $(window).height();
  if (window.innerWidth <= 768) {
    var winTop = $(this).scrollTop();
    if ( winTop > 300 ) {
      header.addClass('js-fixed');
    }
    $(window).on('scroll', function(){
      var winTop = $(this).scrollTop();
      if ( winTop > 300 ) {
        header.addClass('js-fixed');
      } else {
        header.removeClass('js-fixed');
      }
    });
    // $(window).on('scroll', function(){
    //   var winTop = $(this).scrollTop();
    //   if ( winTop > 800 ) {
    //     if ( $(this).scrollTop() < pos ) {
    //       header.addClass('is-visible');
    //     } else {
    //       header.removeClass('is-visible');
    //     }
    //     pos = $(this).scrollTop();
    //   } else if ( winTop > 700 ) {
    //     header.addClass('js-fixed');
    //   } else if ( winTop > 500 ) {
    //     header.addClass('js-transformed');
    //   } else if ( winTop > 450 ) {
    //     header.removeClass('is-visible');
    //   } else {
    //     header.removeClass('js-fixed');
    //     header.removeClass('js-transformed');
    //   }
    // });
  }
});

//スムーススクロール
$(function(){
	$('a[href^="#"]:not(.wishlist-btn)').click(function() {
    var speed = 400; // ミリ秒で記述
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
  });
});

//TOP Introduction Slider
const $slider = $(".p-top__introduction__slider");
$slider.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
  $slider.find(".slick-slide").each((index, el) => {
    const $this = $(el),
      slickindex = $this.attr("data-slick-index");
    if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
      // 現在のスライドが最初のスライドでそこから最後のスライドに戻る場合
      if (slickindex == "-1") {
        // 最後のスライドに対してクラスを付与
        $this.addClass("is-active-next");
      } else {
        // それ以外は削除
        $this.removeClass("is-active-next");
      }
    } else if (nextSlide == 0) {
      // 次のスライドが最初のスライドの場合
      if (slickindex == slick.slideCount) {
        // 最初のスライドに対してクラスを付与
        $this.addClass("is-active-next");
      } else {
        // それ以外は削除
        $this.removeClass("is-active-next");
      }
    } else {
      // それ以外は削除
      $this.removeClass("is-active-next");
    }
  });
});

$slider.slick({
  arrows: true,
  dots: false,
  slidesToShow:2,
});

//TOP Product Slider
$(window).on('load resize', function() {
  if (window.innerWidth <= 768) {
    $('.slick01').slick({
      arrows: true,
      centerMode: true,
      centerPadding: '100px',
      dots: false,
      slidesToShow:2,
    });
  }
});

//コレクション一覧フィルタメニューSP
$(function() {
  $(document).on("click", ".mobile-facets__open", function() {
    $(".p-collection__filtermenu_sp").toggleClass("js-active");
    $(".p-collection__filtermenu_sp__bg").toggleClass("js-active");
  });

  $(".mobile-facets__close").on("click", function() {
    $(".p-collection__filtermenu_sp").toggleClass("js-active");
    $(".p-collection__filtermenu_sp__bg").toggleClass("js-active");
  });

  $(".p-collection__filtermenu_sp__bg").on("click", function() {
    $(".mobile-facets__close").click();
  });
});

//商品詳細スライダー
// $('.p-product_detail__slider').slick({
//   arrows: true,
//   dots: false,
//   slidesToShow:1,
// });

//商品詳細サイズ詳細
$(function() {
  changeVariant();
  $('.js-option').change(function () {
    changeVariant();
  });
  function changeVariant() {
    $('.js-size_detail').hide();
    $("div[data-variant='" + $('[name=color]:checked').data('option') + "-" + $('[name=size]:checked').data('option') + "']").show();
  }
});

//問い合わせフォームのメールアドレスのバリデーションチェック
$(function() {
  $('#ContactForm').on("click", ".contact__button button", function() {
    if ($('#ContactForm-email').val() == "") {
      $('#ContactForm-email').after('<small class="contact__field-error" id="ContactForm-email-error"><span class="visually-hidden">エラー</span><span class="form__message"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg>未入力です</span></small>');
      return false;      
    }
  });  
});